module.exports = __webpack_public_path__ + "img/goods14_4.f11451b8.jpg";